export default __webpack_public_path__ + "static/media/svg-11.51f04f97.svg";